import React from "react";
import Styles from "./styles.module.scss";
import Button from "@Atom/Button";
import NextPrevButton from "@Molecule/NextPrevButton";
import { useNavigate } from "react-router-dom";
import useQuery from "@Hooks/useQuery";

export default function ClassesRules({ data, userSheet }) {
  const navigate = useNavigate();
  const query = useQuery();
  const title = query.get("t");


  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <h3>Aturan Kelas</h3>
        <span>
          Berikut ini adalah beberapa syarat, tata tertib & peraturan yang harus
          diikuti ya!
        </span>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.content}>
        <p>{data.regulationHTML}</p>
      </div>
      <NextPrevButton
        nextText={data.platform === "VIDEO" ? "Lanjut Sesi 1" : "Lanjut Lihat Jadwal"}
        prevText="Sebelumnya"
        disabledNext={userSheet.score.preTest === -1}
        handleNext={() =>
          navigate(data.platform === "VIDEO" ? `/classes/learn/${data._id}/chapter1-material1?t=${title}` : `/classes/learn/${data._id}/schedules?t=${title}` )
        }
        handlePrev={() =>
          navigate(`/classes/learn/${data._id}/pretest?t=${title}`)
        }
      />
    </div>
  );
}
